import { notification } from 'antd';
import API from '../api/jongjonan';

/**
 * Constants
 */

export const FETCHING = 'stats/FETCHING';
export const FETCHING_OK = 'stats/FETCHING_OK';
export const FETCHING_FAILED = 'stats/FETCHING_FAILED';


/**
 * Action Creators
 */
export function fetchStats(params) {
    return async (dispatch) => {
        try {
            dispatch({ type: FETCHING });
            const stats = await API.fetchStats(params);
            dispatch({
                type: FETCHING_OK,
                data: stats.data
            });
        } catch (err) {
            dispatch({
                type: FETCHING_FAILED,
                err: err.response || err.message
            });
            notification.error({
                message: 'Error',
                description: err.message
            });
        }
    }
}


/**
 * Reducer
 */
const initialState = {
    error: false,
    isLoading: false,
    data: []
};

export default function stats(state = initialState, action) {
    switch (action.type) {
        case FETCHING:
            return {
                ...state,
                isLoading: true,
                error: false,
                data: []
            };
        
        case FETCHING_OK:
            return {
                ...state,
                isLoading: false,
                error: false,
                data: action.data
            };
        
        case FETCHING_FAILED:
            return {
                ...state,
                isLoading: false,
                data: [],
                error: action.err
            }
    
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/modules/stats.js